import React from 'react';
 
const messages = [
  'Vérification de la disponibilité...',
  'Connexion avec l\'hôtel...',
  'Confirmation de votre réservation...',
  'Finalisation en cours...',
];
 
export default function BookingLoadingOverlay({ visible }) {
  if (!visible) return null;
 
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(15, 23, 42, 0.55)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        animation: 'overlayFadeIn 0.25s ease',
      }}
    >
      <style>{`
        @keyframes overlayFadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes cardSlideUp {
          from { opacity: 0; transform: translateY(20px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @keyframes pulse-ring {
          0%   { transform: scale(0.8); opacity: 0.8; }
          50%  { transform: scale(1.15); opacity: 0.3; }
          100% { transform: scale(0.8); opacity: 0.8; }
        }
        @keyframes dot-bounce {
          0%, 80%, 100% { transform: translateY(0);    opacity: 0.4; }
          40%            { transform: translateY(-8px); opacity: 1;   }
        }
        @keyframes msg-fade {
          0%   { opacity: 0; transform: translateY(6px);  }
          15%  { opacity: 1; transform: translateY(0);    }
          75%  { opacity: 1; transform: translateY(0);    }
          100% { opacity: 0; transform: translateY(-6px); }
        }
      `}</style>
 
      {/* Card */}
      <div
        style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
          boxShadow: '0 25px 60px rgba(0,0,0,0.25)',
          animation: 'cardSlideUp 0.3s ease',
          minWidth: '300px',
          maxWidth: '380px',
          textAlign: 'center',
        }}
      >
        {/* Spinner with pulse ring */}
        <div style={{ position: 'relative', width: '72px', height: '72px' }}>
          {/* Pulse ring */}
          <div style={{
            position: 'absolute', inset: '-8px',
            borderRadius: '50%',
            border: '3px solid #FF7B47',
            opacity: 0.3,
            animation: 'pulse-ring 1.8s ease-in-out infinite',
          }} />
          {/* Spinner track */}
          <div style={{
            position: 'absolute', inset: 0,
            borderRadius: '50%',
            border: '4px solid #f0f0f0',
          }} />
          {/* Spinner arc */}
          <div style={{
            position: 'absolute', inset: 0,
            borderRadius: '50%',
            border: '4px solid transparent',
            borderTopColor: '#FF7B47',
            borderRightColor: '#FF7B47',
            animation: 'spin 0.9s linear infinite',
          }} />
          {/* Center icon */}
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '24px',
          }}>
            🏨
          </div>
        </div>
 
        {/* Title */}
        <div>
          <p style={{
            color: '#2B4979',
            fontWeight: 700,
            fontSize: '18px',
            marginBottom: '6px',
          }}>
            Réservation en cours
          </p>
          {/* Cycling message */}
          <CyclingMessage messages={messages} />
        </div>
 
        {/* Bouncing dots */}
        <div style={{ display: 'flex', gap: '8px' }}>
          {[0, 1, 2].map(i => (
            <div
              key={i}
              style={{
                width: '8px', height: '8px',
                borderRadius: '50%',
                background: '#FF7B47',
                animation: `dot-bounce 1.2s ease-in-out infinite`,
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </div>
 
        {/* Reassurance text */}
        <p style={{
          color: '#9ca3af',
          fontSize: '12px',
          lineHeight: '1.5',
          maxWidth: '260px',
        }}>
          Veuillez patienter, ne fermez pas cette page.
        </p>
      </div>
    </div>
  );
}
 
// Cycles through messages every 2.5s
function CyclingMessage({ messages }) {
  const [idx, setIdx] = React.useState(0);
  const [key, setKey] = React.useState(0);
 
  React.useEffect(() => {
    const interval = setInterval(() => {
      setIdx(prev => (prev + 1) % messages.length);
      setKey(prev => prev + 1);
    }, 2500);
    return () => clearInterval(interval);
  }, [messages.length]);
 
  return (
    <p
      key={key}
      style={{
        color: '#6b7280',
        fontSize: '14px',
        animation: 'msg-fade 2.5s ease forwards',
        minHeight: '20px',
      }}
    >
      {messages[idx]}
    </p>
  );
}